import React from "react";
import {
  FaCheckCircle,
  FaCalendarCheck,
  FaClock,
  FaHome,
  FaVideo,
} from "react-icons/fa";
import "./AppointmentSuccess.css";

const AppointmentSuccess = ({ appointmentData, onBackToHome }) => {
  const formatDate = (date) => {
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    // Handle both Date object and string formats
    const dateObject = typeof date === 'string' ? new Date(date) : date;
    return dateObject.toLocaleDateString("tr-TR", options);
  };

  return (
    <div className="success-container">
      <div className="success-content">
        <div className="success-icon-container">
          <FaCheckCircle className="success-icon" />
        </div>

        <h1>Randevunuz Başarıyla Oluşturuldu!</h1>
        <p className="success-subtitle">
          Uzman danışmanlarımız sizinle belirtilen tarih ve saatte iletişime
          geçecektir.
        </p>

        <div className="appointment-summary">
          <h3>Randevu Detayları</h3>
          <div className="datetime-display">
            <div className="datetime-item">
              <FaCalendarCheck className="datetime-icon" />
              <div className="datetime-content">
                <span className="datetime-label">Tarih</span>
                <span className="datetime-value">{formatDate(appointmentData.date)}</span>
              </div>
            </div>
            <div className="datetime-separator">•</div>
            <div className="datetime-item">
              <FaClock className="datetime-icon" />
              <div className="datetime-content">
                <span className="datetime-label">Saat</span>
                <span className="datetime-value">{appointmentData.time}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="next-steps">
          <h3>Önemli Bilgiler</h3>
          <ul>
            <li>📧 E-posta adresinize onay mesajı gönderilecektir</li>
            <li>📞 Randevu saatinde mutlaka ulaşılabilir olunuz</li>
            <li>📝 Sorularınızı ve hedeflerinizi önceden hazırlayın</li>
            <li>💼 Randevuya zamanında katılım sağlayın</li>
          </ul>
        </div>

        <div className="contact-info">
          <p>
            <strong>Sorularınız için:</strong>
            <br />
            📞 +49 152 313 90 961
            <br />
            📧 bilgi@almanyakampus.com
          </p>
        </div>

        <button className="home-button" onClick={onBackToHome}>
          <FaHome /> Ana Sayfaya Dön
        </button>
      </div>
    </div>
  );
};

export default AppointmentSuccess;
